import React from 'react'
import {connect} from 'react-redux'

import ChatListItem from './chat_list_item'

class ChatListSegment extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      toggled: true
    }
  }

  toggle () {
    this.setState({toggled: !this.state.toggled})
  }

  renderCarret () {
    if (this.state.toggled) {
      return <i className='rc-icon-caret-down'></i>
    }
    else {
      return <i className='rc-icon-caret-right'></i>
    }
  }

  renderSegmentHeader () {
    return (
      <div className='chat-list-segment-header' onClick={this.toggle.bind(this)}>
        {this.renderCarret()}
        <span>{this.props.label}</span>
      </div>
    )
  }

  renderList (list, {hasIndicator}) {
    if (list && list.size > 0) {
      return (
        list.map((item) => {
          const id = item.get('uid') || item.get('key')

          return (
            <ChatListItem
              key={id}
              id={id}
              item={item}
              hasIndicator={hasIndicator}
              conversationType={this.props.conversationType}
              shouldForceHideRatings={this.props.shouldForceHideRatings}
              shouldShowUnreadMessageCount={this.props.shouldShowUnreadMessageCount}/>
          )
        })
        .toArray()
      )
    }
  }

  renderEmptyMessage (list, emptyMessage) {
    if (emptyMessage && list && list.size === 0) {
      return (
        <em style={{display: 'inline-block', fontStyle: 'italic', fontSize: 12, textAlign: 'center', width: '100%', padding: 5, color: '#C0C0C0'}}>
          {emptyMessage}
        </em>
      )
    }
  }

  renderBody () {
    if (this.state.toggled) {
      return (
        <div className='segment-body'>
          {this.renderEmptyMessage(this.props.list, this.props.emptyMessage)}
          {this.renderList(this.props.list, {hasIndicator: this.props.hasListItemIndicator})}
        </div>
      )
    }
  }

  renderFooter () {
    if (this.props.footer) {
      return (
        <div className='chat-list-segment-footer'>
          {this.props.footer}
        </div>
      )
    }
  }

  render () {
    if (this.props.list) {
      if (this.state.toggled) {
        return (
          <div className='chat-list-segment'>
            {this.renderSegmentHeader()}
            {this.renderBody()}
            {this.renderFooter()}
          </div>
        )
      }
      else {
        return (
          <div className='chat-list-segment closed'>
            {this.renderSegmentHeader()}
            {this.renderBody()}
            {this.renderFooter()}
          </div>
        )
      }
    }
    else {
      return false
    }
  }
}

ChatListSegment.defaultProps = {
  label: 'Chat List Segment',
  hasListItemIndicator: true
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = () => {
  return {}
}

const ChatListSegmentContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ChatListSegment)

export default ChatListSegmentContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_list_segment.js
 **/